import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'notification-manage-error',
  styleUrls: ['./error.component.scss'],
  templateUrl: 'error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ErrorComponent {
  @Output() retry: EventEmitter<void> = new EventEmitter();
}
